import React from "react";
import { useRouter } from "next/router";
import { GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { getSession } from "next-auth/client";
import { TFunction } from "next-i18next";

import Layout from "@/components/Layout";
import OfficeProfile from "@/components/PressOffices/OfficeProfile";
import withAuthentication from "@/components/withAuthentication";
import { OfficeType } from "@/types/office";

const EditorialOfficeProfile = (): React.ReactElement => {
  const router = useRouter();
  const { id } = router.query;

  return <OfficeProfile id={id} />;
};

EditorialOfficeProfile.getLayout = function getLayout(
  page: React.ReactElement,
  t: TFunction
) {
  return (
    <Layout
      title={t("pressOffice.pressOffices")}
      breadcrumb={[
        {
          label: t("pressOffice.pressOffices"),
          isCurrentPage: true,
          href: "/offices",
        },
      ]}
    >
      {page}
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => ({
  props: {
    ...(await serverSideTranslations(ctx.locale, ["common"])),
    session: await getSession(ctx),
  },
});

export default withAuthentication(EditorialOfficeProfile, [
  "user",
  OfficeType.PRESS,
]);
